import { render, staticRenderFns } from "./custom-select.vue?vue&type=template&id=31b76a4f&scoped=true"
import script from "./custom-select.vue?vue&type=script&lang=js"
export * from "./custom-select.vue?vue&type=script&lang=js"
import style0 from "./custom-select.vue?vue&type=style&index=0&id=31b76a4f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b76a4f",
  null
  
)

export default component.exports